<template>
  <div class="qrcode-login">
    <div class="qrcode">
      <div class="mask" v-if="count < 1"></div>
      <el-image
        :src="
          '/api/pc/v4/scan/login/code?id=' +
          uuid
        "
      ></el-image>
    </div>
    <el-button type="text" style="padding-top: 0;" @click="refreshQrcode">点击刷新</el-button>
    <div class="tips">
      <p>打开「dHome」app</p>
      <p>在「设区」页面点击右下角小笔打开扫一扫</p>
    </div>
  </div>
</template>

<script>
import { guid } from "@/utils";
let timer;
export default {
  data() {
    return {
      count: 0,
      uuid: "",
    };
  },
  created() {
    this.refreshQrcode();
  },
  destroyed() {
    clearInterval(timer);
  },
  methods: {
    refreshQrcode() {
      this.uuid = guid();
      // 有效期5分钟
      this.count = 5 * 60;

      clearInterval(timer);
      timer = setInterval(() => {
        console.log(this.count);
        if (this.count <= 1) {
          clearInterval(timer);
        }

        this.count-=3;
        this.$store.dispatch("user/qrcodeLogin", { id: this.uuid }).then(() => {
          this.$router.push({ path: this.redirect || "/" });
        });
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
.qrcode-login {
  display: flex;
  flex-direction: column;
  align-items: center;
  .qrcode {
    width: 200px;
    height: 200px;
    position: relative;
    .mask {
      background: rgba($color: #fff, $alpha: 0.9);
      position: absolute;
      left: 0;
      top: 0;
      z-index: 10;
      width: 100%;
      height: 100%;
    }
  }
  .tips {
    text-align: center;
    font-size: 14px;
    color: #333;
    line-height: 20px;
  }
}
</style>